 export interface ISolarDocumentType {
        name: string;
        code: string;
        documentTypeId:number;
    }

    export class SolarDocumentType implements ISolarDocumentType {
        name: string;
        code: string;
        documentTypeId: number;

        constructor(displayName?: string, code?: string) {
            this.name = displayName;
            this.code = code;
        }

}